module.exports = __webpack_public_path__ + "img/ph.9a781652.svg";